import { styled } from '@mui/system'

export const ConfigurationsPageWrapper = styled('div')`
    .dashboard-page.fraud-defense-configurations {
        .content-item {
            margin-top: 28px;
        }
    }
`
